import dictApi from '@/api/dev/dictApi'
import tool from '@/utils/tool'

const DICT_TREE_KEY = 'DICT_TYPE_TREE_DATA'
const DICT_TREE_VERSION_KEY = 'DICT_TYPE_TREE_VERSION'
const DICT_TREE_SYNC_TIME_KEY = 'DICT_TYPE_TREE_SYNC_TIME'
const DICT_REFRESH_INTERVAL = 5 * 60 * 1000

function cachedTree() {
	const tree = tool.data.get(DICT_TREE_KEY)
	return Array.isArray(tree) && tree.length > 0 ? tree : null
}

function needsRefresh(tree) {
	const lastSyncTime = Number(tool.data.get(DICT_TREE_SYNC_TIME_KEY) || 0)
	return !tree || Date.now() - lastSyncTime >= DICT_REFRESH_INTERVAL
}

function saveTree(tree, version) {
	tool.data.set(DICT_TREE_KEY, tree)
	tool.data.set(DICT_TREE_SYNC_TIME_KEY, Date.now())
	if (version) tool.data.set(DICT_TREE_VERSION_KEY, version)
	else tool.data.remove(DICT_TREE_VERSION_KEY)
}

export async function refreshDictTree({ force = false } = {}) {
	if (!tool.data.get('TOKEN')) return null

	const tree = cachedTree()
	if (!force && !needsRefresh(tree)) return tree

	let version = ''
	let versionRequestFailed = false
	if (tree && !force) {
		try {
			version = String(await dictApi.dictVersion() || '')
			if (version && version === tool.data.get(DICT_TREE_VERSION_KEY)) {
				tool.data.set(DICT_TREE_SYNC_TIME_KEY, Date.now())
				return tree
			}
		} catch (error) {
			// The tree request remains the correctness fallback while older servers roll out.
			versionRequestFailed = true
		}
	}

	const dictTree = await dictApi.dictTree()
	if (!version && !versionRequestFailed) {
		try {
			version = String(await dictApi.dictVersion() || '')
		} catch (error) {
			// The new tree is still valid when the version endpoint is temporarily unavailable.
		}
	}
	saveTree(dictTree, version)
	return dictTree
}
